angular.module('impactx.MenuDirectives').controller('UserInfoCtrl', ['$scope', 'dataGen', '$mdDialog', '$context', '$securityManager', 'LoginService', 'AppConfiguration', 'TranslationService', UserInfoCtrl ]);

function UserInfoCtrl($scope, dataGen, $mdDialog, $context, $securityManager, LoginService, AppConfiguration, TranslationService)
{
    this.userLogoutImage = AppConfiguration.get('useUserLogoutIcon');
    this.context = $context;
    this.translationService = TranslationService;
    var ctrl = this;
    $scope.$watch(function() {
        return $context.$securityManager.isProcessAllowedWatch;
    }, function(newValue) {
        if(newValue) {
            ctrl.visible = $context.$securityManager.isProcessAllowedWatch($scope, "EditProfile", function(newValue) {
                $scope.visible = newValue

            });
        }
    });
    this.show = function (ev)
    {
        $context.refreshUser($scope, dataGen, $context);
        $mdDialog.show({
            controller: "UserinfoDialogCtrl",
            templateUrl: './shared/user/userinfo.tmpl.html',
            targetEvent: ev,
            clickOutsideToClose: true,
            hasBackdrop: false,
            disableParentScroll: false
        });

    };
}